import React, {  useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {   CloseIconBranding } from "../../utils/icons";
import {  StyledModal,StyledTitle, StyledBody,Button, } from "../RecogntionAdmin/corevalues/styles";
import { ShareWorkoutContainer } from "./styles";
import { addSocialInspiration } from "../../redux/actions";
import { showSuccessToast } from "../UserDashboard/ToastHelper";
import ShareWorkoutCard from "./ShareWorkoutCard";

const ShareWorkOutModal = ({ showModal, onClose, /*companyId,*/ title,workoutName,workoutData,addSocialInspiration, history,workoutIcon }) => {



  useEffect(()=>{
  
  },[])
  

  const SuccessToast = () => {
    showSuccessToast("Workout Shared!", `Your workout log has been shared successfully! Check it out on the social feed!`);
  }


  const saveChanges = async () => {
    const payload = {
      "post_images": [],
      "core_value_id": null,
      "description": null,
      "mentioned_users": [],
      "recognition_recipients": [],
      "type_id": 7,
      "post_template_id": null,
      "visibility":"public",
      "workout_log_id": workoutData.id
    }

    addSocialInspiration(payload,1,history,SuccessToast);
    
    
  };





  return (
    <>
      <StyledModal show={showModal} newWidth="584px" newBg="newBg" display="none">
        <Modal.Header closeButton onHide={onClose} style={{ background: "white" }}>
          <StyledTitle>{title || "Share Your Workout"}</StyledTitle>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            {CloseIconBranding("#DA6C74",18,18)}
          </div>
        </Modal.Header>
   
        <StyledBody>
          <ShareWorkoutContainer marginTopToggle="8px">
            <ShareWorkoutCard workoutIcon={workoutIcon} workoutName={workoutName} workoutData={workoutData}/>

            <div className="button-container">
              <div className="done-btn" onClick={onClose}>
                {"Skip"}
              </div>
              <Button
                // isWidth={confirmButtonWidth}
                isHeight="40px"
                background="#DA6C74"
                color="white"
                onClick={saveChanges}
                isWidth="177px"
                margin={"0px"}
              >
                {/* {buttonIcon && buttonIcon} */}
                <div className="btn-text" style={{margin:"0px", display:"flex"}}>{"Share on Social Feed"}
                </div>
              </Button>
            </div>

          </ShareWorkoutContainer>

  


        </StyledBody>
      </StyledModal>

    </>
  );
};

ShareWorkOutModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  title:PropTypes.string,
  workoutName:PropTypes.string,
  workoutData:PropTypes.object,
  addSocialInspiration:PropTypes.func,
  history:PropTypes.object,
  workoutIcon:PropTypes.node,
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
});

const mapDispatchToProps = (dispatch)=>({
  addSocialInspiration: (inspirationData,limit, history,SuccessToast) => dispatch(addSocialInspiration(inspirationData, limit, history,SuccessToast)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ShareWorkOutModal);
